import React, { useState, useEffect, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Stack from "@mui/material/Stack";
import { AddCircle, Delete } from "@mui/icons-material";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  btnWrapper: {
    position: "relative",
  },
}));

const MAX_BUTTONS = 3;

const LOG = process.env.NODE_ENV === "development";
const log = (...args) => LOG && console.log("[FlowBuilderAddButtonModal]", ...args);

const FlowBuilderAddButtonModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [textDig, setTextDig] = useState("");
  const [arrayOption, setArrayOption] = useState([]);
  const [labels, setLabels] = useState({
    title: "Adicionar botões ao fluxo",
    btn: "Adicionar",
  });

  useEffect(() => {
    log("useEffect open=", open, "data?.data?.arrayOption=", data?.data?.arrayOption);
    if (open === "edit") {
      setLabels({ title: "Editar botões", btn: "Salvar" });
      setTextDig(data?.data?.message ?? "");
      const raw = data?.data?.arrayOption?.slice(0, MAX_BUTTONS) || [];
      log("raw arrayOption", raw, "raw[0]=", raw[0], "raw[0]?.value=", raw[0] != null ? raw[0].value : "N/A");
      const normalized = raw
        .filter((o) => o != null)
        .map((o, i) => {
          const val = (o && o.value) != null ? String(o.value) : "";
          log("normalize i=", i, "o=", o, "o.value=", o != null ? o.value : "N/A", "val=", val);
          return { number: i + 1, value: val };
        });
      setArrayOption(normalized.length ? normalized : []);
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({ title: "Adicionar botões ao fluxo", btn: "Adicionar" });
      setTextDig("");
      setArrayOption([]);
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    log("handleSave arrayOption=", arrayOption);
    const options = arrayOption
      .filter((o) => o != null && o.value != null && String(o.value).trim())
      .map((o, idx) => {
        log("handleSave map idx=", idx, "o=", o, "o?.value=", o?.value);
        return { number: idx + 1, value: String((o && o.value) ?? "").trim() };
      });
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { message: textDig || "", arrayOption: options },
      });
    } else {
      handleClose();
      onSave({ message: textDig || "", arrayOption: options });
    }
  };

  const removeOption = (number) => {
    setArrayOption((old) => {
      log("removeOption old=", old, "number=", number);
      const next = old.filter((item) => {
        log("removeOption filter item=", item, "item?.number=", item?.number);
        return item != null && item.number !== number;
      });
      const result = next.map((item, idx) => {
        log("removeOption map item=", item, "idx=", idx);
        return { ...item, number: idx + 1 };
      });
      log("removeOption result=", result);
      return result;
    });
  };

  const addOption = () => {
    if (arrayOption.length >= MAX_BUTTONS) return;
    log("addOption arrayOption.length=", arrayOption.length);
    setArrayOption((old) => {
      log("addOption old=", old);
      return [...old, { number: old.length + 1, value: "" }];
    });
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
        style={{ zIndex: 3000 }}
        PaperProps={{ style: { zIndex: 3000, position: "relative" } }}
        BackdropProps={{
          style: { zIndex: 2999, backgroundColor: "rgba(0, 0, 0, 0.5)" },
        }}
      >
        <DialogTitle id="form-dialog-title">{labels.title}</DialogTitle>
        <Stack spacing={2} sx={{ px: 2, pb: 2 }}>
          <Typography variant="body2" color="textSecondary">
            No WhatsApp (conexão Baileys) serão enviados até 3 botões reais. Em outros canais a mensagem é enviada como texto.
          </Typography>
          <TextField
            label="Mensagem (texto acima dos botões)"
            rows={3}
            multiline
            variant="outlined"
            value={textDig}
            onChange={(e) => setTextDig(e.target.value)}
            className={classes.textField}
            fullWidth
          />
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography>Botões (máx. {MAX_BUTTONS})</Typography>
            <Button
              onClick={addOption}
              color="primary"
              variant="contained"
              disabled={arrayOption.length >= MAX_BUTTONS}
              startIcon={<AddCircle />}
            >
              Adicionar botão
            </Button>
          </Stack>
          {(() => {
            log("render arrayOption=", arrayOption, "length=", arrayOption?.length);
            return arrayOption.map((item, index) => {
              log("render map index=", index, "item=", item, "item?.value=", item != null ? item.value : "N/A");
              const row = item != null ? item : { number: index + 1, value: "" };
              const displayValue = row != null ? (row.value ?? "") : "";
              log("render row=", row, "displayValue=", displayValue);
              return (
                <Stack key={row?.number ?? index} direction="row" spacing={1} alignItems="center">
                  <Typography sx={{ minWidth: 24 }}>{row?.number ?? index + 1}.</Typography>
                  <TextField
                    placeholder="Texto do botão"
                    variant="outlined"
                    value={displayValue}
                    size="small"
                    fullWidth
                    onChange={(e) => {
                      const newVal = e && e.target ? e.target.value : "";
                      log("onChange index=", index, "newVal=", newVal);
                      setArrayOption((old) => {
                        log("onChange updater old=", old, "old[index]=", old[index], "index=", index);
                        const next = [...old];
                        const prev = next[index];
                        log("onChange prev=", prev, "prev?.number=", prev != null ? prev.number : "N/A");
                        next[index] = {
                          number: (prev != null && prev.number != null ? prev.number : index + 1),
                          value: newVal,
                        };
                        log("onChange next=", next);
                        return next;
                      });
                    }}
                  />
                <IconButton onClick={() => removeOption(row?.number ?? index + 1)} size="small">
                  <Delete />
                </IconButton>
              </Stack>
            );
          });
          })()}
        </Stack>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            {i18n.t("contactModal.buttons.cancel")}
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.btnWrapper}
            onClick={handleSave}
          >
            {labels.btn}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddButtonModal;
